import { MenuItem, OutlinedInput, Select } from '@material-ui/core';
import React, { ChangeEvent, memo } from 'react';
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';
import useStyles from './styles';

interface ISelectOption {
  id: string | number,
  text: string,
}
interface ISelectOptionComponent {
  handleChange: (event: any) => void;
  name: string;
  list: ISelectOption[];
  disabled?: boolean,
  defaultOption?: string | number | null;
  isSetSelectOptionDefaultFirst?: boolean,
  valueSetSelectOptionDefaultFirst?: string | number,
  textSetSelectOptionDefaultFirst?: string | number,
}

const SelectOption: React.FC<ISelectOptionComponent> = ({
  handleChange, name, list,
  disabled = false,
  defaultOption = '',
  isSetSelectOptionDefaultFirst = false,
  valueSetSelectOptionDefaultFirst = '',
  textSetSelectOptionDefaultFirst = '---------',
}) => {
  const { control, errors } = useFormContext();
  const classes = useStyles();
  return (
    <Controller
      name={name}
      control={control}
      render={({ ref, ...rest }: ControllerRenderProps) => (
        <Select
          fullWidth={true}
          {...rest}
          inputRef={ref}
          name={name}
          className={classes.selectComponent}
          defaultValue={defaultOption || ''}
          displayEmpty={true}
          disabled={disabled}
          error={!!errors[`${name}`]}
          onChange={(e) => {
            rest.onChange(e);
            handleChange && handleChange(e);
          }}
          input={(<OutlinedInput classes={{ notchedOutline: classes.notchedOutline }} />)}
        >
          {
          isSetSelectOptionDefaultFirst && (<MenuItem key={valueSetSelectOptionDefaultFirst} value={valueSetSelectOptionDefaultFirst} className={classes.selectItemComponent}>{textSetSelectOptionDefaultFirst}</MenuItem>)
          }
          {(list?.length > 0) && list?.map((item: ISelectOption, index) => (
            <MenuItem key={item?.id || index} value={item?.id || ''} className={classes.selectItemComponent}>
              {item?.text || ''}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
};

export default memo(SelectOption);
